import React, {Component} from "react";
import classes from "./styles.module.css";
import Icon from "../Icon";

class VTabBar extends Component {
    state = {
        activeTab: null,
    };

    static Tab = ({children, label, navIcon, navIconSize, isVisible}) => {
        return {children, label, navIcon, navIconSize, isVisible};
    };

    componentDidMount() {
        const {children, defaultActiveTab} = this.props;
        const labels = this.getVisibleLabels(children);
        const firstVisible = labels.length > 0 ? labels[0] : null;
        this.setActiveTab(defaultActiveTab || firstVisible);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) {
            const labels = this.getVisibleLabels(this.props.children);
            const currentTab = this.state.activeTab;
            if (!currentTab || (labels.length > 0 && labels.indexOf(currentTab) === -1)) {
                this.setActiveTab(labels[0]);
            }
        }
    }

    getVisibleLabels = (children) => {
        const result = [];
        React.Children.forEach(children, (child) => {
            if (child && child.props && child.props.isVisible) {
                const labelObj = child.props.label;
                let labelText = "";
                if (labelObj && labelObj.props && labelObj.props.defaultMessage) {
                    labelText = labelObj.props.defaultMessage;
                } else if (typeof labelObj === "string") {
                    labelText = labelObj;
                }
                if (labelText) {
                    result.push(labelText);
                }
            }
        });
        return result;
    };

    setActiveTab = (activeTab) => {
        if (this.state.activeTab !== activeTab && activeTab !== null) {
            this.setState({activeTab});
        }
    };

    renderTabs = () => {
        const {children} = this.props;
        const {activeTab} = this.state;

        return React.Children.map(children, (child) => {
            if (!child || !child.props || !child.props.isVisible) return null;

            const labelObj = child.props.label;
            let labelText = "";
            if (labelObj && labelObj.props && labelObj.props.defaultMessage) {
                labelText = labelObj.props.defaultMessage;
            } else if (typeof labelObj === "string") {
                labelText = labelObj;
            } else {
                return null;
            }

            const isActive = activeTab === labelText;

            return (
                <li key={labelText} className={isActive ? classes.Active : ""}>
                    <span
                        onClick={(e) => {
                            e.stopPropagation();
                            this.setActiveTab(labelText);
                        }}
                    >
                        {child.props.navIcon && (
                            <Icon
                                className={classes.TabIcon}
                                icon={child.props.navIcon}
                                size={child.props.navIconSize || 14}
                            />
                        )}
                        {child.props.label}
                    </span>
                </li>
            );
        });
    };

    render() {
        const {activeTab} = this.state;
        const {children} = this.props;

        return (
            <div className={classes.Wrap}>
                <ul className={classes.Tabs}>
                    {this.renderTabs()}
                </ul>

                <div className={classes.Content}>
                    {React.Children.map(children, (child) => {
                        if (!child || !child.props || !child.props.isVisible) return null;

                        const labelObj = child.props.label;
                        let labelText = "";
                        if (labelObj && labelObj.props && labelObj.props.defaultMessage) {
                            labelText = labelObj.props.defaultMessage;
                        } else if (typeof labelObj === "string") {
                            labelText = labelObj;
                        } else {
                            return null;
                        }

                        if (activeTab === labelText) {
                            return <div>{child.props.children}</div>;
                        }
                        return null;
                    })}
                </div>
            </div>
        );
    }
}

export default VTabBar;


// WEBPACK FOOTER //
// ./src/Components/Utils/VTabBar/index.js